import Icon from '../components/Icon.vue'

Icon.register({
  'balance-scale-left': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M528 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16v-342.8c-4.6-2-8.9-4.3-13-7.1l-142.1 47.6c-8.4 2.8-17.5-1.7-20.3-10.1l-10.2-30.3c-2.8-8.4 1.7-17.5 10.1-20.3l128.4-43c-0.4-3.3-1-6.6-1-10 0-44.2 35.8-80 80-80 29.7 0 55.3 16.4 69.1 40.4l117.9-39.5c8.4-2.8 17.5 1.7 20.3 10.1l10.2 30.3c2.8 8.4-1.7 17.5-10.1 20.3l-132 44.3c-7.3 21.3-23 38.5-43.4 47.5v294.8h176zM640 304c0 44.2-57.3 80-128 80s-128-35.8-128-80h0c0-15.7-2.1-7.3 85-181.5 17.7-35.4 68.2-35.3 85.9 0 86.4 172.8 85.1 165.3 85.1 181.5zM440 288h144l-72-144zM170.9 250.5c86.4 172.8 85.1 165.3 85.1 181.5h0c0 44.2-57.3 80-128 80s-128-35.8-128-80h0c0-15.7-2.1-7.3 85-181.5 17.7-35.4 68.2-35.3 85.9 0zM56 416h144l-72-144z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/balance-scale-left.js
// module id = 642
// module chunks = 0